<template>
  <div class="view-box columns">
      <!-- :header-title="$t(headerTitle)" -->
    <calendar-header
      button-route="new"
      :icon="icon"
      :header-title="headerTitle"
      :show-back-button="showBackButton"
      :back-url="backUrl"
    />
    <keep-alive v-if="keepAlive">
      <router-view></router-view>
    </keep-alive>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import CalendarHeader from './CalendarHeader.vue';
/* eslint no-console: 0 */




export default {
  components: {
    CalendarHeader

  },
  props: {
    headerTitle: { type: String, default: '' },
    icon: { type: String, default: '' },
    keepAlive: {
      type: Boolean,
      default: true,
    },

    showBackButton: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: [String, Object],
      default: '',
    },
  },

};
</script>
